<template>
  <WsMain>
    <WsCRUDTitlebar
      modelName=""
      :label="label"
      :isCreatable="false"
    />
    <v-card
      class="mt-6"
      elevation="1"
    >
      <WsDataTable
        pageMode
        rowClickRead
        :getCustomReadUrl="$_getCustomReadUrl"
        :inRowBtnUpdate="false"
        :inRowBtnDelete="false"
        :items="items"
        :itemsPerPage="15"
        :fields="fields"
        :headers="headers"
        :dataTotalCount="dataTotalCount"
        :currentPage="currentPage"
        :lastPage="lastPage"
        :showExpand="false"
        @pageto="$_onGoToPage($event)"
      />
    </v-card>
  </WsMain>
</template>

<script>
import model from "@/models/subscriptionApiDemo";

export default {
  data() {
    return {
      label: model.label,
      items: model.index.items,
      fields: model.index.fields,
      headers: model.index.headers,
      dataTotalCount: 1,
      currentPage: 1,
      lastPage: 1,
    };
  },
  methods: {
    $_getCustomReadUrl($event) {
      return `/subscription_api_demo/${$event.value}`;
    },
    $_onGoToPage($event) {
      this.currentPage = $event;
    }
  },
};
</script>